// extracted by mini-css-extract-plugin
module.exports = {"dialogAlerrtSuccessAdd":"DialogAlertSuccessAdd_dialogAlerrtSuccessAdd_K6cdD"};